﻿import * as layerTypes from '../../../../map/utils/layerTypes';
import * as paths from '../../../../map/utils/paths';
export default class DwgDxfExportControl {
    constructor(mapControl, layerSettingsHandler, resourcesHandler, classId, exportFormat, geometry, modalWrapper, rootURL) {
        this.mapControl = mapControl;
        this.map = mapControl.map;
        this.layerSettingsHandler = layerSettingsHandler;
        this.resourcesHandler = resourcesHandler;
        this.classId = classId;
        this.exportFormat = exportFormat;
        this.geometry = geometry;
        this.modalWrapper = modalWrapper;
        this.rootURL = rootURL;
        this.exportWrapper = 'export-wrapper-' + this.classId;
        this.exportContainer = 'export-container-' + this.classId;
        this.cancelExportId = 'cancel-export-' + this.classId;
        this.saveExportId = 'save-export-' + this.classId;
        this.exportLayerTree = 'export-layer-tree-' + this.classId;
        this.exportLayerOptions = 'export-layer-options-' + this.classId;
        this.exportLayerLineColor = 'export-layer-line-color-' + this.classId;
        this.exportLayerLineWeight = 'export-layer-line-weight-' + this.classId;
        this.exportPointFormat = 'export-point-format-' + this.classId;
        this.exportPointFileName = 'export-point-file-name-' + this.classId;
        this.exportPointBlockName = 'export-point-block-name-' + this.classId;
        this.exportPointBlockScale = 'export-point-block-scale-' + this.classId;
        this.exportLayerAttributes = 'export-layer-attributes-' + this.classId;
        this.exportFileName = 'export-file-name-' + this.classId;
        this.exportAttributes = 'export-attributes-' + this.classId;
        this.exportAttributesAsExtData = 'export-attributes-as-ext-data-' + this.classId;
        this.init();
    }

    init() {
        $('#' + this.modalWrapper)[0].innerHTML = this._getExportTemplate();
        this._addEvents();
    }

    _getExportTemplate() {
        return `<div class="general-settings-wrapper panel config-modal" id="` + this.exportWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 pl-0 pr-0 pb-0">
                            <div class="form-row general-settings-title-row m-0 col-12">
                                <label class="form-label general-settings-title ml-3">` + this.resourcesHandler.get('ExportTitle').replaceAll('{format}', this.exportFormat) + `</label>
                            </div>
                            <div class="form-row mb-3 pl-4 pr-4 pt-3">
                                <div class="form-group col-6">
                                    <label class="form-label">` + this.resourcesHandler.get('ExportFileName') + `</label>
                                    <input class="form-control" id="` + this.exportFileName + `" type="text"/>
                                </div>
                                <div class="col-3 mb-3 align-content-start pt-4">
                                    <div class="form-group mt-3" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                                        <label class="form-label ml-3 mt-3">` + this.resourcesHandler.get('ExportDwgAttributes') + `</label>
                                        <div style="margin-top: 0.6rem;" id="` + this.exportAttributes + `"></div>
                                    </div>
                                </div>
                                <div class="col-3 mb-3 align-content-start pt-4">
                                    <div class="form-group mt-3" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                                        <label class="form-label ml-3 mt-3">` + this.resourcesHandler.get('ExportAttributesAsExtData') + `</label>
                                        <div style="margin-top: 0.6rem;" id="` + this.exportAttributesAsExtData + `"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row col-12 pl-4">
                                <label class="form-label ml-2">` + this.resourcesHandler.get('ExportLayerSettings') + `</label>
                            </div>
                            <div class="form-row mb-0 pl-3 pr-3 pt-3" id="` + this.exportContainer + `">
                                <div class="form-group col-4 export-tree-container">
                                    <div id="` + this.exportLayerTree + `" class="export-layer-tree"></div>
                                </div>
                                <div class="form-group col-8 export-layer-options" id="` + this.exportLayerOptions + `">
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelExportId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                            <button id="` + this.saveExportId + `" class="btn btn-primary ml-2" title="` + this.resourcesHandler.get('Export') + `" type="button">` + this.resourcesHandler.get('Export') + `</button>
                        </div>
                    </div>
                </div>`;
    }

    _addEvents() {
        $('#' + this.cancelExportId).on('click', () => {
            this._hidePanel();
        });

        $('#' + this.saveExportId).on('click', () => {
            this._exportFile();
        });

        $('#' + this.exportFileName).val('layers_export');

        $('#' + this.exportAttributes).kendoSwitch({
            messages: {
                checked: '',
                unchecked: ''
            },
            checked: false
        });

        $('#' + this.exportAttributesAsExtData).kendoSwitch({
            messages: {
                checked: '',
                unchecked: ''
            },
            checked: false
        });

        let layers = JSON.parse(JSON.stringify(this.mapControl.layerSettingsHandler.layers)).filter(x => (x.Type == 'ENTITY' && x.VisibleByDefault == true) || x.Type == 'GROUP');

        layers.forEach(item => {
            if (item.Items != null) {
                this.filterLayers(item);
            }

            if (item.IdDefaultStyle != null) {
                this._handlePropertiesFromStyle(item, this.mapControl.layerHandler.styleHandler.getStyleById(item.IdDefaultStyle));
            }

            item.checked = false;

            if (item.url != null) {
                delete item.url;
            }
        });

        layers = layers.filter(x => x.Type != 'GROUP' || x.items.length > 0);

        $('#' + this.exportLayerTree).kendoTreeView({
            dataSource: layers,
            checkboxes: {
                name: 'checked',
                checkChildren: true
            },
            loadOnDemand: false,
            dataTextField: "Title",
            dataValueField: "Id",
            select: (e) => {
                this._selectField(e);
            },
            template: (e) => {
                return this._getNodeTemplate(e);
            }
        });
    }

    _exportFile() {
        let exportFileName = $('#' + this.exportFileName).val().toLowerCase();

        if (this.exportFormat == 'DWG') {
            if (!exportFileName.endsWith('.dwg')) {
                exportFileName = exportFileName + '.dwg';
            }
        } else {
            if (!exportFileName.endsWith('.dxf')) {
                exportFileName = exportFileName + '.dxf';
            }
        }

        let url = this.rootURL + 'map/ExportMapLayers?keepFile=false&fileName=' + exportFileName;

        let data = {
            Format: this.exportFormat,
            IdMap: this.mapControl.mapId * 1,
            Srs: this.mapControl.map.getView().getProjection().getCode(),
            WktFilter: this.geometry,
            ExportAttr: $('#' + this.exportAttributes).data('kendoSwitch').check(),
            ExportAttrAsExtData: $('#' + this.exportAttributesAsExtData).data('kendoSwitch').check(),
            Layers: []
        }

        this._addLayers($('#' + this.exportLayerTree).data('kendoTreeView').dataSource.data(), data.Layers);
        showLoadingPanel();
        $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(data),
            async: true,
            contentType: "application/json; charset=utf-8",
            xhrFields: {
                responseType: "blob"
            },
            success: (blob, status, xhr) => {
                hideLoadingPanel();
                let filename = "";
                let disposition = xhr.getResponseHeader("Content-Disposition");
                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }

                if (!filename) filename = exportFileName;


                let downloadUrl = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();

                setTimeout(function () {
                    window.URL.revokeObjectURL(downloadUrl);
                    document.body.removeChild(a);
                }, 100);
            },
            error: (e) => {
                hideLoadingPanel();
            }
        });
    }

    _addLayers(layers, data) {
        layers.forEach(layer => {
            if (layer.checked && layer.Type == 'ENTITY') {
                let layerData = {
                    IdLayer: layer.Id,
                    Options: layer.exportOpts.toJSON()
                }

                let hex = layerData.Options.Color;

                if (hex.startsWith("#")) hex = hex.slice(1);

                let rgb = parseInt(hex, 16);

                let r = (rgb >> 16) & 0xFF;
                let g = (rgb >> 8) & 0xFF;
                let b = (rgb) & 0xFF;

                let color = (b << 16) | (g << 8) | r;

                layerData.Options.Color = color;

                if (layer.Filters != null) {
                    layerData.Filter = JSON.stringify(layer.Filters.toJSON());
                }

                if (layer.Id < 0) {
                    layerData.IdExtConn = layer.IdExtConn;
                }

                layerData.Options.AttrList = [];

                if (layerData.Options.attributes != null && layerData.Options.attributes.length > 0 && layerData.Options.attributes[0].items != null) {
                    layerData.Options.attributes[0].items.forEach(attrItem => {
                        if (attrItem.checked) {
                            layerData.Options.AttrList.push(attrItem.Title);
                        }
                    }); 
                }

                delete layerData.Options.attributes;

                if (layerData.Options.AttrList.length == 0) {
                    delete layerData.Options.AttrList;
                }

                data.push(layerData);
            }

            if (layer.Type == 'GROUP' && layer.items != null && layer.items.length > 0) {
                this._addLayers(layer.items, data);
            }
        });
    }

    _handlePropertiesFromStyle(item, style) {
        let rule;

        if (style.style && style.style.rules && style.style.rules.length > 0) {
            rule = style.style.rules[0];
        }

        let pointSymbolizer;
        let lineSymbolizer;
        let polygonSymbolizer;


        if (rule) {
            if (rule.pointsymbolizer != null) {
                pointSymbolizer = rule.pointsymbolizer;
            }

            if (rule.linesymbolizer != null) {
                lineSymbolizer = rule.linesymbolizer;
            }

            if (rule.polygonsymbolizer != null) {
                polygonSymbolizer = rule.polygonsymbolizer;
            }
        }

        let color = '#000000';
        let width = 100;

        if (polygonSymbolizer != null && polygonSymbolizer.stroke != null && polygonSymbolizer.stroke.styling != null) {
            let styling = polygonSymbolizer.stroke.styling;

            if (styling.stroke != null && typeof styling.stroke == 'string') {
                color = styling.stroke;
            }
        }

        if (lineSymbolizer != null && lineSymbolizer.stroke != null && lineSymbolizer.stroke.styling != null) {
            let styling = lineSymbolizer.stroke.styling;

            if (styling.stroke != null && typeof styling.stroke == 'string') {
                color = styling.stroke;
            }
        }

        if (pointSymbolizer != null && pointSymbolizer.graphic != null && pointSymbolizer.graphic.mark != null) {
            let mark = pointSymbolizer.graphic.mark;

            if (mark.fill != null && mark.fill.styling != null && mark.fill.styling.fill != null && typeof mark.fill.styling.fill == 'string') {
                color = mark.fill.styling.fill;
            }

            if (mark.stroke != null && mark.stroke.styling != null) {
                let stroke = mark.stroke.styling;

                if (stroke.stroke != null && typeof stroke.stroke == 'string') {
                    color = stroke.stroke;
                }
            }
        }

        if (color.indexOf('#') != 0) {
            color = '#000000';
        }

        item.exportOpts = {
            Color: color,
            LineWeight: width
        };
    }

    _selectField(node) {
        let item = node.sender.dataSource.getByUid(node.node.getAttribute('data-uid'));
        if (item.Type == 'ENTITY') {
            let url = this.rootURL + paths.MAP_ENTITY_GET_FIELDS + item.Entity.Id;

            if (item.exportOpts == null || item.exportOpts.attributes == null) {
                $.ajax({
                    type: "GET",
                    url: url,
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        this._selectNode(node.node.getAttribute('data-uid'), item, result);
                    }
                });
            } else {
                this._selectNode(node.node.getAttribute('data-uid'), item, null);
            }
        }
    }

    _selectNode(uid, item, fields) {
        let geomType = item.Entity.GeometryFieldType;

        if (geomType == null) {
            geomType = 'POINT';
        }

        let template = `<div class="form-row">
                            <h4 class="export-layer-title col-12 mb-4">` + item.Title + `</h4>
                        </div>
                        <div class="form-row p-3">
                            <div class="form-group col-6">
                                <label class="form-label">` + this.resourcesHandler.get('ExportLineColor') + `</label>
                                <input class="form-control" id="` + this.exportLayerLineColor + `" type="color"/>
                            </div>
                            <div class="form-group col-6">
                                <label class="form-label">` + this.resourcesHandler.get('ExportLineWeight') + `</label>
                                <input class="form-control" id="` + this.exportLayerLineWeight + `"/>
                            </div>` +
                            (geomType == 'POINT' ? `
                            <div class="form-group col-6">
                                <label class="form-label">` + this.resourcesHandler.get('ExportPointFormat') + `</label>
                                <input class="form-control" id="` + this.exportPointFormat + `"/>
                            </div>
                            <div class="form-group col-6 export-point-specifics" style="display: none;">
                                <label class="form-label">` + this.resourcesHandler.get('ExportPointFileName') + `</label>
                                <input class="form-control" id="` + this.exportPointFileName + `"/>
                            </div>
                            <div class="form-group col-6 export-point-specifics" style="display: none;">
                                <label class="form-label">` + this.resourcesHandler.get('ExportPointBlockName') + `</label>
                                <input class="form-control" id="` + this.exportPointBlockName + `"/>
                            </div>
                            <div class="form-group col-6">
                                <label class="form-label">` + this.resourcesHandler.get('ExportPointBlockScale') + `</label>
                                <input class="form-control" id="` + this.exportPointBlockScale + `"/>
                            </div>
                            ` : ``)
                            +
                            `</div>
                        <div class="form-row pl-3">
                            <label class="form-label col-12 mb-3">` + this.resourcesHandler.get('ExportAttributes') + `:</label>
                        </div>
                        <div class="form-row" id="` + this.exportLayerAttributes + `">

                        </div>`;

        $('#' + this.exportLayerOptions)[0].innerHTML = template;

        if (item.exportOpts == null) {
            item.exportOpts = {
                Color: '#000000',
                LineWeight: 100
            };
        }

        $('#' + this.exportLayerLineColor).kendoColorPicker({
            buttons: false,
            value: item.exportOpts.Color,
            change: (e) => {
                item.exportOpts.Color = e.sender.value();
            }
        });

        $('#' + this.exportLayerLineWeight).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            dataSource: [{
                id: 0,
                name: '0'
            }, {
                id: 100,
                name: '100'
            }, {
                id: 200,
                name: '200'
            }],
            change: (e) => {
                item.exportOpts.LineWeight = e.sender.value();
            }
        });

        if (item.exportOpts.LineWeight != null) {
            $('#' + this.exportLayerLineWeight).data('kendoComboBox').value(item.exportOpts.LineWeight);
        }


        if (geomType == 'POINT') {
            if (item.exportOpts.Point == null) {
                item.exportOpts.Point = {
                    Format: 'point',
                    BlockScale: 1
                };
            }

            $('#' + this.exportPointFormat).kendoComboBox({
                dataTextField: 'name',
                dataValueField: 'id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                dataSource: [{
                    id: 'file',
                    name: this.resourcesHandler.get('ExportDwgFile')
                }, {
                    id: 'point',
                    name: this.resourcesHandler.get('ExportDwgPoint')
                }, {
                    id: 'rectangle',
                    name: this.resourcesHandler.get('ExportDwgRectangle')
                }, {
                    id: 'circle',
                    name: this.resourcesHandler.get('ExportDwgCircle')
                }],
                change: (e) => {
                    if (e.sender.value() == 'file') {
                        $('.export-point-specifics').show();
                    } else {
                        $('.export-point-specifics').hide();
                    }

                    item.exportOpts.Point.Format = e.sender.value();
                }
            });

            if (item.exportOpts.Point.Format != null) {
                $('#' + this.exportPointFormat).data('kendoComboBox').value(item.exportOpts.Point.Format);

                if (item.exportOpts.Point.Format == 'file') {
                    $('.export-point-specifics').show();
                }
            }

            $('#' + this.exportPointFileName).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                dataSource: {
                    serverFiltering: true,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                let filter = $('#' + this.exportPointFileName).data('kendoComboBox').text();

                                if (filter == null) {
                                    filter = '';
                                }
                                return this.rootURL + 'map/GetDwgTplFiles?filter=' + filter;
                            }
                        }
                    }
                },
                change: (e) => {
                    item.exportOpts.Point.FileName = e.sender.value();

                    if (item.exportOpts.Point.FileName == null || item.exportOpts.Point.FileName == '') {
                        $('#' + this.exportPointBlockName).data('kendoComboBox').readonly(true);
                        $('#' + this.exportPointBlockName).data('kendoComboBox').value(null);
                    } else {
                        $('#' + this.exportPointBlockName).data('kendoComboBox').readonly(false);
                        $('#' + this.exportPointBlockName).data('kendoComboBox').trigger('change');
                        $('#' + this.exportPointBlockName).data('kendoComboBox').dataSource.read();
                        $('#' + this.exportPointBlockName).data('kendoComboBox').value(null);
                    }
                }
            });

            if (item.exportOpts.Point.FileName != null) {
                $('#' + this.exportPointFileName).data('kendoComboBox').value(item.exportOpts.Point.FileName);
            }

            $('#' + this.exportPointBlockName).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                template: (dataItem) => {
                    return '<img src="' + dataItem.Attr[0] + '" width="32" height="32" /><span class="k-state-default ml-2">' + dataItem.Name + '</span>'
                },
                dataSource: {
                    serverFiltering: true,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                let filter = $('#' + this.exportPointBlockName).data('kendoComboBox').text();

                                if (filter == null) {
                                    filter = '';
                                }

                                let fileName = $('#' + this.exportPointFileName).data('kendoComboBox').value();

                                if (fileName == null) {
                                    fileName = '';
                                }

                                return this.rootURL + 'map/GetDwgBlocks?fileName=' + fileName + '&filter=' + filter;
                            }
                        }
                    }
                },
                change: (e) => {
                    item.exportOpts.Point.BlockName = e.sender.value();
                }
            });

            if (item.exportOpts.Point.FileName == null || item.exportOpts.Point.FileName == '') {
                $('#' + this.exportPointBlockName).data('kendoComboBox').readonly(true);
            }

            if (item.exportOpts.Point.BlockName != null) {
                $('#' + this.exportPointBlockName).data('kendoComboBox').value(item.exportOpts.Point.BlockName);
            }

            $('#' + this.exportPointBlockScale).kendoNumericTextBox({
                value: item.exportOpts.Point.BlockScale,
                change: (e) => {
                    item.exportOpts.Point.BlockScale = e.sender.value();
                }
            });
        }

        if (item.exportOpts.attributes == null) {
            let attributes = [{
                Title: this.resourcesHandler.get('AllAttributes'),
                Id: 0,
                checked: false,
                items: []
            }];

            if (fields != null) {
                fields.forEach(field => {
                    if (field.DataType != 'GEOMETRY') {
                        attributes[0].items.push({
                            Title: field.FieldName,
                            Id: field.Id,
                            checked: false
                        });
                    }
                });
            }

            item.exportOpts.attributes = attributes;
        }

        $('#' + this.exportLayerAttributes).kendoTreeView({
            dataSource: item.exportOpts.attributes,
            checkboxes: {
                name: 'checked',
                checkChildren: true
            },
            loadOnDemand: false,
            dataTextField: "Title",
            dataValueField: "Id",
            check: (e) => {
                let selection = e.sender.dataSource.getByUid(e.node.getAttribute('data-uid'));
                item.exportOpts.attributes[0].items.find(x => x.Id == selection.Id).checked = selection.checked;
            }
        });
    }

    _getNodeTemplate(node) {
        let layer = node.item;

        return this._getPrintLegendIcon(layer) + '<span class="export-layer-node">' + layer.Title + '</span>';
    }

    _getPrintLegendIcon(layer) {
        let template = ``;

        if (layer.Id == layerTypes.MEASUREMENTS) {
            template = `<span class="fal fa-ruler legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.Id == layerTypes.DIMENSIONING) {
            template = `<span class="fal fa-arrows-h legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.Id == layerTypes.REDLINE) {
            template = `<span class="fal fa-pencil-paintbrush legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
        }
        else if (layer.Type == layerTypes.GROUP) {
            template = `<span class="fal fa-object-group legend-preview-icon" style="font-size: 1rem;"></span>`;
        } else if (layer.Type == layerTypes.GEOSERVICE) {
            if (layer.Geoservice.LegendUrl != null && layer.Geoservice.LegendUrl.trim() != '') {
                template = `<img style="height: 24px; width: 24px;" class="legend-preview-image" src="` + (this.rootURL + paths.PROXY_URL + this.mapId + '/' + layer.Fid.replaceAll('-', '') + layer.Geoservice.LegendUrl) + `"></img>`;
            } else {
                template = `<span class="fal fa-globe legend-preview-icon" style="font-size: 1rem; margin-left: 4px; margin-right: 3px;"></span>`;
            }
        }

        if (layer.IdDefaultStyle != null && layer.IdDefaultStyle > 0) {
            template = `<img style="height: 24px; width: 24px;" class="legend-preview-image" src="` + (this.rootURL + paths.LAYER_PREVIEW_URL.replaceAll('{id}', layer.IdDefaultStyle).replaceAll('{rule}', 0)) + `"></img>`;
        }

        return template;
    }

    filterLayers(layer) {
        let items = layer.Items.filter(x => (x.Type == 'ENTITY' && x.VisibleByDefault == true) || x.Type == 'GROUP');

        layer.items = items;

        layer.items.forEach(item => {
            if (item.Items != null) {
                this.filterLayers(item);
            }

            if (item.IdDefaultStyle != null) {
                this._handlePropertiesFromStyle(item, this.mapControl.layerHandler.styleHandler.getStyleById(item.IdDefaultStyle));
            }

            item.checked = false;

            if (item.url != null) {
                delete item.url;
            }
        });
        layer.checked = false;
        layer.items = layer.items.filter(x => x.Type != 'GROUP' || x.items.length > 0);
    }

    _hidePanel() {
        $('#' + this.modalWrapper)[0].innerHTML = '';
    }
}